import {
  CollectiveQueryResult,
  CollectiveProposalQueryResult
} from 'graphql/generated'
import React, { useState } from 'react'
import CommandSummaryTable from 'components/Collectives/CollectiveProposals/CreateProposal/CommandSummaryTable'
import Button from 'components/Button'
import { twMerge } from 'tailwind-merge'

type TProposal = Pick<
  NonNullable<CollectiveProposalQueryResult['collectiveProposal']>,
  'id' | 'commands' | 'publicUrl'
>
export type TCollective = Pick<
  NonNullable<CollectiveQueryResult['collective']>,
  | 'id'
  | 'name'
  | 'treasuryBalance'
  | 'parameters'
  | 'tokens'
  | 'safeThreshold'
  | 'parameters'
  | 'governanceType'
  | 'network'
  | 'totalMembers'
>

const SHOWMORE_LIMIT = 3

function DetailedCommandsRenderer({
  collective,
  proposal
}: {
  collective: TCollective
  proposal: TProposal
  limitedView?: boolean
}) {
  const commands = proposal.commands
  const [showCount, setShowCount] = useState<number | undefined>(SHOWMORE_LIMIT)

  return (
    <>
      <div className={twMerge('overflow-auto mb-2 transition-all')}>
        <CommandSummaryTable
          commands={commands.slice(0, showCount)}
          collective={collective}
        />
      </div>

      {commands.length > SHOWMORE_LIMIT && (
        <Button
          onClick={() =>
            setShowCount(
              showCount === SHOWMORE_LIMIT ? undefined : SHOWMORE_LIMIT
            )
          }
          color="lightgray"
          showFocusRing={false}
          label={
            showCount !== SHOWMORE_LIMIT
              ? 'Show less'
              : `+ ${commands.length - SHOWMORE_LIMIT} more commands`
          }
        />
      )}
    </>
  )
}

export default DetailedCommandsRenderer
